import AgentsAmountRanges from "@models/errors/components/AgentsAmountRanges";
import { plainToInstance } from "class-transformer";
import {CreateLightPaymentPayload, createPaymentPayload} from "@/services/operations/payment/PaymentService";
import PurchaseOperation from "@models/operations/PurchaseOperation";
import ServiceMainApi from "@/services/v2/service-main-api/ServiceMainApi";

export default class PurchaseRepository {
    async getAgentsAmountRanges(): Promise<AgentsAmountRanges> {
        const { data } = await ServiceMainApi.of().get<{ data: any }>('/api/mobile/client/payments/sumRange');
        return plainToInstance(AgentsAmountRanges, data, {
            excludeExtraneousValues: true
        }) as unknown as AgentsAmountRanges;
    }

    async patchEmptyPayment(payload: CreateLightPaymentPayload): Promise<PurchaseOperation> {
        const response = await ServiceMainApi.of().patch<{ data: object }>(`/api/mobile/client/payments/process`, payload);
        return plainToInstance(PurchaseOperation, response.data, {
            excludeExtraneousValues: true,
            excludePrefixes: ['_']
        });
    }
}
